/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-header[_ngcontent-%COMP%]   .company-logo[_ngcontent-%COMP%]{margin:0 auto;background-position:center;width:155px}"];
export { styles as styles };
